import { render, staticRenderFns } from "./DiscountsBoxComponent.vue?vue&type=template&id=4a301d88&scoped=true&"
import script from "./DiscountsBoxComponent.vue?vue&type=script&lang=js&"
export * from "./DiscountsBoxComponent.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsBoxComponent.vue?vue&type=style&index=0&id=4a301d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a301d88",
  null
  
)

export default component.exports